export const REVALIDATE_SECONDS = 60;

export const ITEMS_LIMIT = 24;
